import { render, staticRenderFns } from "./CheckRevisionQuestionSettings.vue?vue&type=template&id=cf3804a0&"
import script from "./CheckRevisionQuestionSettings.vue?vue&type=script&lang=js&"
export * from "./CheckRevisionQuestionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports